import React from "react";
import { ButtonProps } from "./types";
import styles from "./styles";
import { observer } from "mobx-react-lite";

/* Note: In a form, if you press enter, the first button is essentially clicked.
 * If say you have a cancel button & then a submit button,
 * make sure the cancel button type is set to "button"
 * Valid types: button|submit|reset */

const Button = observer((props: ButtonProps) => {
  const {
    className,
    onClick,
    text = "submit",
    disabled = false,
    type = "button",
    colour = "dark",
    ...rest
  } = props;

  const clickHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (type !== "submit" && event != null) {
      event.preventDefault();
    }

    if (onClick != null) {
      onClick(event);
    }
  }

  const cssClassNames = [styles.elements.button];

  if (colour !== "unset") {
    cssClassNames.push(`btn-${colour}`);
  }

  if (className != null) {
    cssClassNames.push(className);
  }

  const cssClassName = cssClassNames.join(" ");

  return (
    <button
      className={cssClassName}
      type={type}
      disabled={disabled}
      onClick={clickHandler}
      {...rest}
      dangerouslySetInnerHTML={{ __html: text }}
    ></button>
  )
});

export default Button;
